import { rect, cRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

// Narrow silhouette, longer legs
export const body_slim: Hull = {
  id: 'body_slim',
  name: 'Slim',
  drawBody: (ctx, p) => {
    // Head (slightly narrower)
    rect(ctx, 27, 7, 10, 11, p.light);
    rect(ctx, 27, 7, 1, 11, p.shadow);
    rect(ctx, 36, 7, 1, 11, p.shadow);
    rect(ctx, 28, 7, 8, 1, p.shadow);
    rect(ctx, 28, 17, 8, 1, p.shadow);
    // Neck
    rect(ctx, 30, 18, 4, 2, p.light);
    // Shoulders
    cRect(ctx, 20, 14, 2, p.light);
    // Arms
    rect(ctx, 23, 22, 4, 13, p.light);
    rect(ctx, 37, 22, 4, 13, p.light);
    // Torso (10 wide)
    rect(ctx, 27, 22, 10, 13, p.light);
    rect(ctx, 27, 22, 1, 13, p.shadow);
    rect(ctx, 36, 22, 1, 13, p.shadow);
    // Hips
    rect(ctx, 27, 35, 10, 2, p.shadow);
    // Left leg (longer)
    rect(ctx, 27, 37, 5, 17, p.light);
    rect(ctx, 27, 37, 1, 17, p.shadow);
    // Right leg
    rect(ctx, 32, 37, 5, 17, p.light);
    rect(ctx, 36, 37, 1, 17, p.shadow);
  },
  mounts: {
    [SLOT.HEAD]:   { anchor: { x: 32, y: 7 } },
    [SLOT.FACE]:   { anchor: { x: 32, y: 12 } },
    [SLOT.HAT]:    { anchor: { x: 32, y: 7 } },
    [SLOT.TORSO]:  { anchor: { x: 32, y: 20 } },
    [SLOT.WAIST]:  { anchor: { x: 32, y: 35 } },
    [SLOT.FOOT_L]: { anchor: { x: 29, y: 53 } },
    [SLOT.FOOT_R]: { anchor: { x: 35, y: 53 } },
  },
};
